/* src/app/modules/print-cards/components/cards/card-content/business-cards-2x3/generic-business-card-stack-content/generic-business-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
:host .main-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  box-sizing: border-box;
  width: 10.5rem;
  padding: 0.6875rem 0.625rem;
}
:host .main-content .brand-name-and-label-container {
  display: flex;
  flex-direction: column;
}
:host .main-content .brand-name-and-label-container .product-card-badge-outer {
  display: flex;
  padding-bottom: 0.625rem;
  min-height: 1.375rem;
}
:host .main-content .brand-name-and-label-container .product-card-badge-outer .product-card-badge-inner {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 0.5rem;
}
:host .main-content .brand-name-and-label-container .product-card-badge-outer .product-card-badge {
  width: 1.375rem;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .brand-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.25rem;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .brand-name .brand-and-name {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .brand-name .brand-and-name .product-card-brand {
  font-family: poppins, sans-serif;
  font-weight: 500;
  padding-bottom: 0.25rem;
  font-size: 0.5625rem;
  line-height: 100%;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .brand-name .brand-and-name .product-card-name {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 100%;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .print-card-label {
  align-self: flex-start;
  height: 0.875rem;
  margin: 0;
  padding: 0;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .print-card-label ::ng-deep .product-label {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-size: 0.625rem;
  line-height: 100%;
  box-sizing: border-box;
  height: 0.875rem;
  border-radius: 0.1125rem;
  margin: 0.625rem 0 0 0;
  padding: 0 0.125rem;
  width: fit-content;
}
:host .main-content .type-and-price-container {
  display: flex;
  flex-direction: column;
}
:host .main-content .type-and-price-container .type-and-price {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  align-items: center;
  justify-content: flex-end;
  height: 1.5625rem;
}
:host .main-content .type-and-price-container .type-and-price .product-card-type {
  flex: 1;
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-size: 0.75rem;
  font-size: 0.5625rem;
  line-height: 100%;
}
:host .main-content .type-and-price-container .type-and-price .product-card-price ::ng-deep .product-variant-price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 100%;
  overflow: visible;
}
:host .main-content .type-and-price-container .type-and-price .product-card-price ::ng-deep .product-variant-price .product-variant-previous-price {
  opacity: 0.5;
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 0.5625rem;
}
:host .color-strip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  width: 7.5rem;
  padding: 0 0.625rem;
  gap: 0.125rem;
}
:host .color-strip .property-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  height: 1.46875rem;
  gap: 0.25rem;
  border-bottom: 1px solid #dadbde;
}
:host .color-strip .property-container .title {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-size: 0.5625rem;
  line-height: 120%;
}
:host .color-strip .property-container .value {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 0.5625rem;
  line-height: 120%;
  text-align: right;
}
:host ::ng-deep .force-bold-style * {
  font-family: poppins, sans-serif;
  font-weight: 800;
}
:host ::ng-deep .force-italic-style * {
  font-family: poppins, sans-serif;
  font-style: italic;
  font-weight: 700;
}
/*# sourceMappingURL=generic-business-card-stack-content.component.css.map */
